window.customilyShopify = window.customilyShopify || {};
window.customilyShopify.hooks = {
  onAppLoaded: function () {
    $('#customily-personalize-button').insertBefore($('.buy-buttons__wrapper'));
  },
};

window.customilyShopify ??= {};
window.customilyShopify.buttons = {
  ...window.customilyShopify.buttons,
  forceAttachPersonalizeButtonVariant: true,
  forceAttachCartButtonVariant: true,
  forceAttachPreviewButton: true,
};

// Adds SVG icon to Customily personalize button
const addIconToPersonalizeButton = () => {
  const customilyButton = document.getElementById('customily-personalize-button');
  if (!customilyButton) return;

  if (customilyButton.querySelector('svg')) return;

  const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svgIcon.setAttribute('width', '20');
  svgIcon.setAttribute('height', '20');
  svgIcon.setAttribute('viewBox', '0 0 16 17');
  svgIcon.setAttribute('fill', 'none');
  svgIcon.innerHTML =
    '<path d="M4 4.53339C4.28571 3.39053 4.85714 2.8191 6 2.53339C4.85714 2.24767 4.28571 1.67624 4 0.533386C3.71429 1.67624 3.14286 2.24767 2 2.53339C3.14286 2.8191 3.71429 3.39053 4 4.53339Z" stroke="#E1083E" stroke-width="1.06677" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.49686 10.2022C7.55566 7.80933 12.22 3.13636 14.1934 3.03569C15.4135 2.91902 12.982 7.24996 7.21964 11.9896M2.5 14.9371C2.97336 13.2657 2.67468 14.0871 2.83602 12.1623C2.92269 11.8769 3.09537 10.9929 4.17611 10.5522C5.40419 10.0508 6.30491 10.8082 6.53759 11.1642C7.22364 11.9076 7.30297 12.831 6.53759 13.8857C5.77221 14.9405 3.50273 15.2025 2.5 14.9371Z" stroke="#E1083E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>';
  customilyButton.insertBefore(svgIcon, customilyButton.firstChild);
};

// Ensures personalize button stays outside height-observer and fixes position after variant changes
const ensurePersonalizeButtonPosition = () => {
  const personalizeButton = document.getElementById('customily-personalize-button');
  const buyButtonsWrapper = document.querySelector('.buy-buttons__wrapper');

  if (!personalizeButton || !buyButtonsWrapper) return;

  const heightObserver = personalizeButton.closest('height-observer');

  if (heightObserver) {
    buyButtonsWrapper.parentElement.insertBefore(personalizeButton, buyButtonsWrapper);

    addIconToPersonalizeButton();

    setTimeout(() => {
      const becomingFixedWrapper = document.querySelector('becoming-fixed');
      if (becomingFixedWrapper && typeof becomingFixedWrapper.initialSetup === 'function') {
        becomingFixedWrapper.initialSetup();
      }
    }, 350);
  }
};

const personalizeButtonObserver = new MutationObserver(() => {
  ensurePersonalizeButtonPosition();
});

// Initializes DOM observation for personalize button
const startObserving = () => {
  const productInfo = document.querySelector('.product-info');
  if (productInfo) {
    personalizeButtonObserver.observe(productInfo, {
      childList: true,
      subtree: true,
    });
    ensurePersonalizeButtonPosition();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startObserving);
} else {
  startObserving();
}

// Adds personalization text to preview-opener elements (used in PLP and cart)
const addTextToPreviewOpeners = () => {
  const previewOpeners = document.querySelectorAll('.preview-opener');
  const translations = window.theme?.translations?.customily || {};

  previewOpeners.forEach((previewOpener) => {
    // Hide preview for line items without actual personalization properties
    const lineItem = previewOpener.closest('line-item');
    if (lineItem) {
      const propertiesList = lineItem.querySelector('ul.unstyled-list');
      const hasVisibleProperties = propertiesList && propertiesList.querySelectorAll('li').length > 0;
      if (!hasVisibleProperties) {
        const customilyProperty = previewOpener.closest('.customily-property');
        if (customilyProperty) {
          customilyProperty.style.display = 'none';
        }
        return;
      }
    }

    const paragraph = previewOpener.querySelector('p.personalization-text');
    if (!paragraph) {
      const p = document.createElement('p');
      p.className = 'personalization-text';
      p.innerHTML = `${translations.previewText || 'Articolo con'} <span style="font-weight: bold;">${translations.previewBold || 'personalizzazione'}</span>.`;
      previewOpener.insertBefore(p, previewOpener.firstChild);
    }

    previewOpener.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Preview') {
        const previewText = document.createElement('span');
        previewText.className = 'preview-text';
        previewText.textContent = 'Preview';
        previewText.style.textDecoration = 'underline';
        previewText.style.cursor = 'pointer';
        node.replaceWith(previewText);
      }
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addTextToPreviewOpeners);
} else {
  addTextToPreviewOpeners();
}

const previewOpenerObserver = new MutationObserver(() => {
  addTextToPreviewOpeners();
});

previewOpenerObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

window.addEventListener('customily-options-loaded', (event) => {
  setupCursorTracking();
  addModalPersonalizationInfo();
  addModalTermsAndConditions();
  addIconToPersonalizeButton();
  addTextToPreviewOpeners();
  setupCustomilySwatches();


  // Re-apply swatch styles when swatches reappear (e.g. after character count goes back to ≤7)
  const customilyAccordion = document.getElementById('customily-personalize-accordion');
  if (customilyAccordion) {
    const swatchObserver = new MutationObserver(() => {
      setupCustomilySwatches();
    });
    swatchObserver.observe(customilyAccordion, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }
});

// Sets up cursor tracking for Customily close button
function setupCursorTracking() {
  const customilyContainer = document.querySelector('.customily-modal-container');
  const customilyCloseButton = document.querySelector('.customily-close-button.d-none.d-sm-flex');

  if (!customilyContainer || !customilyCloseButton) return;

  const MOUSE_EVENTS = ['mousemove', 'mouseover', 'mouseenter'];

  MOUSE_EVENTS.forEach((eventType) => {
    customilyContainer.addEventListener(eventType, (event) => {
      const x = event.clientX - customilyCloseButton.offsetWidth / 2;
      const y = event.clientY - customilyCloseButton.offsetHeight / 2;
      customilyContainer.style.cssText = `--_customily-cursor-x: ${x}px; --_customily-cursor-y: ${y}px;`;
    });
  });
}

// Adds personalization info to modal (different behavior for mobile and desktop)
function addModalPersonalizationInfo() {
  const customilyAccordion = document.getElementById('customily-personalize-accordion');
  if (!customilyAccordion) return;

  const translations = window.theme?.translations?.customily || {};
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const clHeader = document.querySelector('.cl-header');

  if (isMobile && clHeader) {
    const h3 = document.createElement('h3');
    h3.className = 'text-m';
    h3.textContent = translations.modalTitle || 'Personalizza il tuo prodotto';

    const closeButton = clHeader.querySelector('.customily-close-button');
    if (closeButton) {
      clHeader.insertBefore(h3, closeButton);
    } else {
      clHeader.prepend(h3);
    }

    const infoDiv = document.createElement('div');
    infoDiv.className = 'modal-personalization-info text-start';
    infoDiv.innerHTML =
      `<p class="text-s">${translations.modalDescription || 'Scegli come desideri personalizzare il tuo prodotto. Il costo della personalizzazione ammonta a'} <span class="text-s-demi">${translations.priceLabel || '+ 3,00 €'}</span>.</p>`;
    customilyAccordion.parentNode.insertBefore(infoDiv, customilyAccordion);
  } else {
    const infoDiv = document.createElement('div');
    infoDiv.className = 'modal-personalization-info text-start';
    infoDiv.innerHTML =
      `<h3 class="text-m">${translations.modalTitle || 'Personalizza il tuo prodotto'}</h3><p class="text-s">${translations.modalDescription || 'Scegli come desideri personalizzare il tuo prodotto. Il costo della personalizzazione ammonta a'} <span class="text-s-demi">${translations.priceLabel || '+ 5,00 €'}</span>.</p>`;
    customilyAccordion.parentNode.insertBefore(infoDiv, customilyAccordion);
  }
}

// Adds terms and conditions after cart buttons
function addModalTermsAndConditions() {
  const cartButtons = document.querySelector('.buttons-container-col');
  if (!cartButtons) return;

  const translations = window.theme?.translations?.customily || {};
  const termsDiv = document.createElement('div');
  termsDiv.className = 'modal-personalization-terms text-start text-s';
  const termsUrl = translations.termsUrl || '#';
  termsDiv.innerHTML = `<p>${translations.termsText || 'Accetto'} <a href="${termsUrl}">${translations.termsLink || 'termini e condizioni'}</a> ${translations.termsSuffix || 'della personalizzazione'}</p>`;
  cartButtons.parentNode.insertBefore(termsDiv, cartButtons.nextSibling);
}

// Configures Customily swatches (colors and options) - handles focus, dimensions and styles
function setupCustomilySwatches() {
  const customilySwatch = document.querySelectorAll('.customily-swatch');

  customilySwatch.forEach((swatch) => {
    const label = swatch.querySelector('label');
    const isColorSwatch = swatch.closest('.custom-swatch-color');

    if (label.classList.contains('label-focus')) {
      label.style.border = '1px solid #656565';
    }

    if (isColorSwatch) {
      label.style.height = '20px';
      label.style.width = '20px';
      label.style.maxWidth = '20px';
      label.style.minWidth = '20px';
      label.style.maxHeight = '20px';
      label.style.minHeight = '20px';
    }

    const img = label.querySelector('img');
    if (img) {
      img.removeAttribute('style');
    }

    const input = swatch.querySelector('input');
    if (input) {
      input.addEventListener('change', () => {
        setTimeout(() => {
          const parentOption = swatch.closest('.customily_option');

          if (parentOption) {
            parentOption.querySelectorAll('.customily-swatch label').forEach((otherLabel) => {
              otherLabel.style.removeProperty('border');
              otherLabel.style.removeProperty('outline');
              otherLabel.style.removeProperty('outline-offset');
            });
          }

          if (isColorSwatch) {
            label.style.setProperty('height', '20px', 'important');
            label.style.setProperty('width', '20px', 'important');
            label.style.setProperty('outline', '1px solid black', 'important');
            label.style.setProperty('outline-offset', '3px', 'important');
          } else {
            label.style.setProperty('border', '1px solid #656565', 'important');
          }

          const img = label.querySelector('img');
          if (img) {
            img.removeAttribute('style');
          }
        }, 0);
      });
    }
  });
}

// Handles removing personalization product when removing a customizable product
class CartRemoveWithPersonalization {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const removeLink = e.target.closest('a[href*="/cart/change"][href*="quantity=0"]');
      if (!removeLink) return;

      const isInModal = this.isInRemoveModal(removeLink);
      const isDirectRemove = removeLink.classList.contains('line-item__remove-button');
      const isModalTrigger = removeLink.hasAttribute('data-modal-trigger');
      const isInMinicart = this.isInMinicart(removeLink);

      const hasDataAttr = removeLink.hasAttribute('data-has-personalization');
      const nextPersonalizationUrl = this.getNextPersonalizationRemoveUrl(removeLink);

      if ((hasDataAttr || nextPersonalizationUrl) && ((isInModal && !isModalTrigger) || isDirectRemove)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.removeWithPersonalization(removeLink.getAttribute('href'), isInMinicart, nextPersonalizationUrl);
      }
    }, true);
  }

  getNextPersonalizationRemoveUrl(removeLink) {
    // Cart drawer: line-items are direct siblings
    const lineItem = removeLink.closest('line-item');
    if (lineItem) {
      const nextLineItem = lineItem.nextElementSibling;
      if (nextLineItem && nextLineItem.tagName.toLowerCase() === 'line-item' && nextLineItem.querySelector('a[href*="/products/personalizzazione"]')) {
        const removeBtn = nextLineItem.querySelector('a[href*="/cart/change"][href*="quantity=0"]');
        if (removeBtn) return removeBtn.getAttribute('href');
      }
    }

    // Cart page: find the order-summary__row (from modal confirm or direct link)
    let orderRow = null;

    // If inside a modal, find the trigger link's row
    const modal = removeLink.closest('[role="dialog"]');
    if (modal && modal.id) {
      const triggerLink = document.querySelector(`[aria-controls="${modal.id}"]`);
      if (triggerLink) {
        orderRow = triggerLink.closest('.order-summary__row');
      }
    }

    // Or directly from the link's row
    if (!orderRow) {
      orderRow = removeLink.closest('.order-summary__row');
    }

    if (orderRow) {
      // Traverse siblings skipping <hr>, customizable divs, etc.
      let sibling = orderRow.nextElementSibling;
      while (sibling) {
        if (sibling.classList.contains('order-summary__row')) {
          if (sibling.querySelector('a[href*="/products/personalizzazione"]')) {
            const removeBtn = sibling.querySelector('a[href*="/cart/change"][href*="quantity=0"]');
            if (removeBtn) return removeBtn.getAttribute('href');
          }
          break;
        }
        sibling = sibling.nextElementSibling;
      }
    }

    return null;
  }

  isInRemoveModal(button) {
    const modal = button.closest('[role="dialog"]');
    return modal && modal.id && modal.id.includes('modal-remove');
  }

  isInMinicart(button) {
    const cartDrawer = button.closest('cart-drawer-custom');
    return cartDrawer !== null;
  }

  /**
   * Extracts the line item key from a cart change URL
   * @param {string} url - The cart change URL (e.g., "/cart/change?id=12345:hash&quantity=0")
   * @returns {string|null} - The line item key
   */
  extractKeyFromUrl(url) {
    try {
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('id');
    } catch {
      return null;
    }
  }

  /**
   * Finds the personalization product key linked to the main product
   * Uses _customily-upsell-main-id and _customily-upsell-id properties to find the connection
   * @param {string} mainProductKey - The key of the main product being removed
   * @returns {Promise<string|null>} - The key of the linked personalization product
   */
  async findPersonalizationProduct(mainProductKey) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const mainProduct = cart.items.find(item => item.key === mainProductKey);
      if (!mainProduct || !mainProduct.properties) {
        return null;
      }

      const upsellMainId = mainProduct.properties['_customily-upsell-main-id'];
      if (!upsellMainId) {
        return null;
      }
      
      const personalizationProduct = cart.items.find(item => 
        item.properties && 
        item.properties['_customily-upsell-id'] === upsellMainId
      );
      
      return personalizationProduct ? personalizationProduct.key : null;
    } catch (error) {
      console.error('Error finding personalization product:', error);
      return null;
    }
  }

  async removeWithPersonalization(removeUrl, isInMinicart = false, fallbackPersonalizationUrl = null) {
    try {

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      
      const mainProductKey = this.extractKeyFromUrl(removeUrl);
      
      const personalizationKey = mainProductKey ? await this.findPersonalizationProduct(mainProductKey) : null;
      
      const removePromises = [fetch(removeUrl)];
      
      if (personalizationKey) {
        const personalizationUrl = `/cart/change?id=${personalizationKey}&quantity=0`;
        removePromises.push(fetch(personalizationUrl));
      } else if (fallbackPersonalizationUrl) {
        removePromises.push(fetch(fallbackPersonalizationUrl));
      }
      
      await Promise.all(removePromises);
      
      if (isInMinicart) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {

        window.location.reload();
      }
    } catch (error) {
      console.error('Error removing personalized product:', error);
      
      if (isInMinicart) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
      
      window.location.reload();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartRemoveWithPersonalization();
  });
} else {
  new CartRemoveWithPersonalization();
}
